import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { PopupPosition } from './HolidayInfoAndApprovalPopup';

interface Props {
  isVisible: boolean;
  triggerRect?: DOMRect;
  popupPositioning?: PopupPosition;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: React.ReactNode;
}

export function HolidayPopupShell({ isVisible, triggerRect, popupPositioning, onMouseEnter, onMouseLeave, children }: Props) {
  if (!isVisible || !triggerRect) return null;

  const verticalStyle: React.CSSProperties = triggerRect.bottom > window.innerHeight / 2
    ? { bottom: Math.max(8, window.innerHeight - triggerRect.top + 4) }
    : { top: triggerRect.bottom + 4 };
  const horizontalStyle: React.CSSProperties = popupPositioning === PopupPosition.Right
    ? { right: Math.max(8, window.innerWidth - triggerRect.right) }
    : { left: Math.max(8, triggerRect.left) };

  return ReactDOM.createPortal(
    <Wrapper style={{ ...verticalStyle, ...horizontalStyle }} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {children}
    </Wrapper>,
    document.body,
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 448px;
  min-width: 300px;
  min-height: 50px;
  padding: 24px;
  position: fixed;
  z-index: 999999;
  background: #FFFFFF;
  box-shadow: 0 2px 8px 2px rgba(76, 109, 172, 0.15);
  border-radius: 24px;
  cursor: default;
  p {
    max-width: 100%;
  }
`;
